import { CarouselModalSlide, Typography } from '@repo/ui';
import {
  GATE_1_SLIDE_IDS,
  type Gate1SlideId,
} from 'contexts/analytics/events/gates';
import styles from '../ConditionsEducationalModal.module.css';
import MicrobiomeConnectionsSlide from './MicrobiomeConnectionsSlide';
import SensitiveMetricFlagsSlide from './SensitiveMetricFlagsSlide';

export type EducationalSlide = {
  id: Gate1SlideId;
  slide: CarouselModalSlide;
};

export const STATIC_SLIDES: EducationalSlide[] = [
  {
    id: GATE_1_SLIDE_IDS.WHAT_THIS_PAGE_SHOWS,
    slide: (
      <Typography variant='heading-l' className={styles.headingText}>
        This page shows links between specific microbiome features and certain
        health conditions found in research.
      </Typography>
    ),
  },
  {
    id: GATE_1_SLIDE_IDS.NOT_A_DIAGNOSIS,
    slide: (
      <>
        <Typography variant='heading-l' className={styles.headingText}>
          It is not a diagnosis.
        </Typography>
        <Typography
          variant='body-s'
          className={styles.headingText}
          color='warm-grey-700'
        >
          Flagged metrics do not mean you have or will develop a condition.
        </Typography>
      </>
    ),
  },
  {
    id: GATE_1_SLIDE_IDS.ASSOCIATION_NOT_CAUSE,
    slide: (
      <>
        <Typography variant='heading-l' className={styles.headingText}>
          Certain microbiome patterns may be associated with a condition without
          causing it.
        </Typography>
        <Typography
          variant='body-s'
          className={styles.headingText}
          color='warm-grey-700'
        >
          These microbiome patterns are found in people without this condition
          too.
        </Typography>
      </>
    ),
  },
  {
    id: GATE_1_SLIDE_IDS.FLAG_NOT_PRESENCE,
    slide: (
      <>
        <Typography variant='heading-l' className={styles.headingText}>
          A flagged metric does not mean a condition is present.
        </Typography>
        <Typography
          variant='body-s'
          className={styles.headingText}
          color='warm-grey-700'
        >
          Factors such as diet, genetics, lifestyle and more can cause flagged
          metrics.
        </Typography>
      </>
    ),
  },
  {
    id: GATE_1_SLIDE_IDS.MICROBIOME_CONNECTIONS,
    slide: MicrobiomeConnectionsSlide,
  },
  {
    id: GATE_1_SLIDE_IDS.SENSITIVE_METRIC_FLAGS,
    slide: SensitiveMetricFlagsSlide,
  },
];
